<form class="form-horizontal" #form="ngForm" (ngSubmit)="saveAsistanceTicket()" *ngIf="!isTiketInfo">
  <div class="container">
    <div class="row mb-3">
      <div class="form-group col">
        <p> <img alt="" class="me-2"
            [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/location_client.svg' | company">
          <strong>{{
            'Current location data ' | translate }} </strong>
        </p>
      </div>
    </div>
    <div class="row mb-3">
      <div class="form-group col-sm-4">
        <label>{{ "Country" | translate }}</label>
        <select name="origin_country_id" class="form-control" [(ngModel)]="assistancecase.origin_country_id" disabled>
          <option *ngFor="let country of countries" [ngValue]="country.id">
            {{ country.name }}
          </option>
        </select>
      </div>
      <div class="form-group col-sm-4">
        <label class="control-label">{{ 'State' | translate }}</label>
        <select name="state_origin_id" class="form-control" (ngModelChange)="onSelectState($event)"
          [(ngModel)]="assistancecase.state_id" disabled>
          <option [ngValue]="null">---</option>
          <option *ngFor="let state of states" [ngValue]="state.id">
            {{ state.name }}
          </option>
        </select>
      </div>
      <div class="form-group col-sm-4">
        <label class="control-label">{{ 'District' | translate }} / {{ "Mayoralty" | translate }}</label>
        <select name="state_district_origin_id" class="form-control" (ngModelChange)="onSelectStateDistrict($event)"
          [(ngModel)]="assistancecase.state_district_id" disabled>
          <option [ngValue]="null">---</option>
          <option *ngFor="let state of statesDistrict" [ngValue]="state.id">
            {{ state.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="form-group col-sm-4">
        <label>{{ 'Postal code' | translate }}</label>
        <input type="text" class="form-control" [(ngModel)]="assistancecase.postal_code" name="postal_code" disabled>
      </div>
      <div class="form-group col-sm-4">
        <label>{{ 'Street' | translate }}</label>
        <input type="text" class="form-control" [(ngModel)]="assistancecase.street" name="street" disabled>
      </div>
      <div class="form-group col-sm-4">
        <label>{{ 'External number' | translate }}</label>
        <input type="number" class="form-control" [(ngModel)]="assistancecase.zone" name="zone" disabled>
      </div>
    </div>
    <div class="row mb-5">
      <div class="form-group col-sm-4">
        <label>{{ 'Suburb' | translate }}</label>
        <input type="text" class="form-control" [(ngModel)]="assistancecase.suburb" name="suburb" disabled>
      </div>
      <div class="form-group col-sm-4">
        <label>{{ 'Reference point' | translate }}</label>
        <input type="text" class="form-control md" [(ngModel)]="assistancecase.reference" name="reference" disabled>
      </div>
      <div class="form-group col-sm-4">
        <label>{{ 'Full Address' | translate }}</label>
        <textarea type="text" class="form-control md" rows="3" cols="10" [(ngModel)]="assistancecase.address"
          name="address" disabled>
        </textarea>
      </div>
    </div>



    <div class="row">
      <div [ngClass]="have_coordinates ? 'col-md-8' : 'col-12'">
        <p-messages [enableService]="false" [(value)]="msgs" [closable]="false"></p-messages>
      </div>
    
      <div *ngIf="have_coordinates" class="col-md-4 d-flex align-items-center">
        <button 
          (click)="openLinkLocationCustomer($event)" 
          class="btn secundary-btn-green" 
          style="width: fit-content;">
          {{ 'Get client location' | translate }}
        </button>
      </div>
    </div>
    


    <hr class="mb-3">
    <div class="row mb-3">
      <div class="col">
        <div class="form-group col-sm-3">
          <div class="form-check">
            <input class="form-check-input" [(ngModel)]="enableEditing" name="enableEditing" type="checkbox"
              id="flexCheckDefault">
            <label class="form-check-label text-info" for="flexCheckDefault">
              {{'Edit destination address' | translate}}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="form-group col">
        <p> <img alt="" class="me-2"
            [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/location_client.svg' | company">
          <strong>{{'Destination address' | translate }} </strong>
        </p>
      </div>
    </div>
    <div class="row mb-3">
      <div class="form-group col-sm-4">
        <label>{{ "Country" | translate }}</label>
        <select name="destination_country_id" class="form-control" (ngModelChange)="onSelectCountryDestination($event)"
          [(ngModel)]="assistancecase.destination_country_id" required [disabled]="!enableEditing">
          <option *ngFor="let country of countries" [ngValue]="country.id">
            {{ country.name }}
          </option>
        </select>
      </div>
      <div class="form-group col-sm-4">
        <label>{{ 'State' | translate }}</label>
        <select name="state_id" class="form-control" (ngModelChange)="onSelectStateTicket($event)"
          [(ngModel)]="editticket.state_id" required [disabled]="!enableEditing">
          <option [ngValue]="null">---</option>
          <option *ngFor="let state of statesTicket" [ngValue]="state.id">
            {{ state.name }}
          </option>
        </select>
      </div>
      <div class="form-group col-sm-4">
        <label>{{ 'District' | translate }} / {{ "Mayoralty" | translate }}</label>
        <select name="state_district_id" class="form-control" [(ngModel)]="editticket.state_area_id" required
          [disabled]="!enableEditing">
          <option [ngValue]="null">---</option>
          <option *ngFor="let state of statesDistrictTicket" [ngValue]="state.id">
            {{ state.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="form-group col-sm-4">
        <label>{{ 'Postal code' | translate }}</label>
        <input type="text" class="form-control" [(ngModel)]="editticket.postal_code_destination"
          name="postal_code_destination" required [disabled]="!enableEditing">
      </div>
      <div class="form-group col-sm-4">
        <label>{{ 'Street' | translate }}</label>
        <input type="text" class="form-control" [(ngModel)]="editticket.street_destination" name="street_destination"
          required [disabled]="!enableEditing">
      </div>
      <div class="form-group col-sm-4">
        <label>{{ 'External number' | translate }}</label>
        <input type="number" class="form-control" [(ngModel)]="editticket.zone_destination" name="zone_destination"
          [disabled]="!enableEditing">
      </div>
    </div>
    <div class="row mb-3">
      <div class="form-group col-sm-4">
        <label>{{ 'Suburb' | translate }}</label>
        <input type="text" class="form-control" [(ngModel)]="editticket.suburb_destination" name="suburb_destination"
          [disabled]="!enableEditing">
      </div>
      <div class="form-group col-sm-4">
        <label>{{ 'Full Address' | translate }}</label>
        <textarea type="text" rows="3" cols="10" class="form-control md" [(ngModel)]="editticket.address_destination"
          name="address_destination" required [disabled]="!enableEditing">
        </textarea>
      </div>
    </div>
    <div class="row mb-4" [hidden]="!enableEditing">
      <div class="col">
        <app-select-location #selectLocationComp [location]="caseLocation" [memberLocation]="memberLocationDestination" [ticketstep]="true" [showMap]="showMap"
          [stateLocation]="eventLocation" [requireDataLatLng]="true" (selectLocation)="step1SetLocation($event)">
        </app-select-location>
        <label *ngIf="!this.editticket.latitude || !this.editticket.longitude" class="text-danger fs-4">*{{ 'Select a destination' | translate }}</label>
        <input type="hidden" class="form-control" [(ngModel)]="this.editticket.latitude" name="latitudeDestiny"
          required>
        <input type="hidden" class="form-control" [(ngModel)]="this.editticket.longitude" name="longitudeDestiny"
          required>
      </div>
    </div>
    <div class="row">
      <div class="col text-end">
        <button [hidden]="!enableEditing" type="submit" class="btn primary-btn primary-btn-fw"
          [disabled]="form.form.invalid">{{ 'Save' | translate }}</button>
      </div>
    </div>
  </div>
</form>
<form class="form-horizontal" #form="ngForm" (ngSubmit)="saveAsistanceTicket()" *ngIf="isTiketInfo">
  <div class="container">
    <div class="row mb-3">
      <div class="form-group col">
        <p> <img alt="" class="me-2"
            [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/star_circle.svg' | company">
          <strong>{{
            'Information' | translate }} </strong>
        </p>
      </div>
    </div>
    <div class="row mb-3">
      <div class="form-group col-sm-6">
        <label>{{ 'Ticket information' | translate }}</label>
        <textarea type="text" class="form-control md" rows="3" cols="10" [(ngModel)]="assistancecase.case_ticket_info"
          name="case_ticket_info" disabled>
        </textarea>
      </div>
    </div>
  </div>
</form>